module.exports = __webpack_public_path__ + "img/left-quote.af2b4a6b.svg";